var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/ContainerGridExtension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-grid.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/forms/x-checkbox.js";
import "@adornis/forms/x-input.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseContainer } from "../../db/extensions/BaseContainer.js";
import {
  BaseContainerGrid,
  BaseContainerGridColumnSize,
  BaseContainerGridTableView
} from "../../db/extensions/BaseContainerGrid.js";
import "../components/x-icon-button.js";
import "../components/x-infobox.js";
import { convertDataBySize, getExtensionForData } from "../globals/methods.js";
import "./../x-buildify-dropzone.js";
import { ContainerExtension, XContainerExtension } from "./ContainerExtension.js";
import { EditExtensionData } from "./EditExtensionData.js";
var ContainerGridExtension = {
  class: BaseContainerGrid,
  toolbar: { icon: "grid_view", text: { default: "Grid" } },
  defaultValues: {
    ...ContainerExtension.defaultValues,
    columns: { global: 3 },
    rows: { global: 1 }
  },
  render(instance, { isSubelement, dropzoneBefore, dropzoneAfter }) {
    return xComponents(html`
      <x-container-grid-extension
        .content=${instance}
        .defaultValues=${this.defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-container-grid-extension>
    `);
  },
  group: "Layout",
  editor({ content, contentController, controllerBaseKeyPath, host, globalSettings, extensions }) {
    if (!content.columnSizeDefinitions)
      content.columnSizeDefinitions = [];
    const size = contentController.size;
    const extension = getExtensionForData(content, extensions);
    const convertedContent = convertDataBySize(content, extension, size);
    return html`
      <x-flex space="md">
        <x-input
          clearable
          placeholder="Anzahl Spalten"
          type="number"
          ${contentController.field(...controllerBaseKeyPath, "columns")}
        ></x-input>
        <x-input
          clearable
          placeholder="Anzahl Reihen"
          type="number"
          ${contentController.field(...controllerBaseKeyPath, "rows")}
        ></x-input>

        <x-infobox>
          Um den Abstand der Kacheln innerhalb des Grids zu verändern, kannst du den Wert für den vertikalen oder den
          horizontalen Abstand vergrößern und verkleinern.
        </x-infobox>

        <x-buildify-spacing-picker
          clearable
          select
          placeholder="Abstand zwischen den Spalten"
          ${contentController.field(...controllerBaseKeyPath, "gridColumnGap")}
          select
        ></x-buildify-spacing-picker>
        <x-buildify-spacing-picker
          clearable
          select
          placeholder="Abstand zwischen den Reihen"
          ${contentController.field(...controllerBaseKeyPath, "gridRowGap")}
          select
        ></x-buildify-spacing-picker>

        <x-checkbox
          .label=${"Anordnung der Items im Grid umdrehen"}
          ${contentController.field(...controllerBaseKeyPath, "revertDirection")}
        ></x-checkbox>

        <x-infobox>
          Geben Sie für jede Spalte an, wie viele Anteile des verfügbaren Platzes sie einnehmen soll. Zum Beispiel: Wenn
          Sie die Werte 1, 2, 1 eingeben, werden die Spalten im Verhältnis 1:2:1 aufgeteilt.
        </x-infobox>

        ${new Array(convertedContent.ensuredColumns).fill(null).map((_, index) => {
      const definition = content.columnSizeDefinitions.find((def) => def.index === index);
      if (!definition) {
        content.columnSizeDefinitions.push(new BaseContainerGridColumnSize({ index }));
      }
      const controllerIndex = content.columnSizeDefinitions.findIndex((def) => def.index === index);
      if (controllerIndex === -1)
        throw new Error("column size defintion not found");
      return html`
            <x-flex horizontal space-between crossaxis-center>
              <x-text> ${index + 1}. Spalte </x-text>
              <x-buildify-spacing-picker
                placeholder="Breite"
                unit="fr"
                unit-translation="Anteile"
                ${contentController.field(...controllerBaseKeyPath, "columnSizeDefinitions", controllerIndex, "width")}
              >
              </x-buildify-spacing-picker>
            </x-flex>
          `;
    })}
        ${content.tableView ? html`
              <x-infobox> Tabellenoptik </x-infobox>
              <x-checkbox
                .label=${"Horizontale Linien hinzuf\xFCgen"}
                ${contentController.field(...controllerBaseKeyPath, "tableView", "hasHorizontalSeperator")}
              ></x-checkbox>
              <x-checkbox
                .label=${"Vertikale Linien hinzuf\xFCgen"}
                ${contentController.field(...controllerBaseKeyPath, "tableView", "hasVerticalSeperator")}
              ></x-checkbox>
              <x-buildify-spacing-picker
                placeholder="Breite der Linien"
                ${contentController.field(...controllerBaseKeyPath, "tableView", "thickness")}
              ></x-buildify-spacing-picker>
              <x-buildify-color-picker
                placeholder="Farbe der Linien"
                ${contentController.field(...controllerBaseKeyPath, "tableView", "colorSeperators")}
              ></x-buildify-color-picker>
              <x-icon-button
                icon="delete"
                text="Tabellenoptik entfernen"
                @click=${() => {
      content.tableView = null;
      host.requestUpdate();
    }}
              ></x-icon-button>
            ` : html`
              <x-icon-button
                icon="add"
                text="Tabellenoptik hinzufügen"
                @click=${() => {
      content.tableView = new BaseContainerGridTableView({});
      host.requestUpdate();
    }}
              ></x-icon-button>
            `}

        <x-h3> Vorschau des Layouts </x-h3>
        <x-grid
          columns=${new Array(convertedContent.ensuredColumns).fill(null).map((_, index) => convertedContent.getColumnWidthByIndex(index)).join(" ")}
          ${css({ gridColumnGap: convertedContent.gridColumnGap ?? "", gridRowGap: convertedContent.gridRowGap ?? "" })}
        >
          ${new Array(convertedContent.ensuredColumns * convertedContent.ensuredRows).fill(null).map(() => {
      return html`
              <x-flex
                ${css({
        width: "100%",
        height: "20px",
        background: "#fff",
        border: "4px solid #bbbbb4",
        borderRadius: "4px"
      })}
              ></x-flex>
            `;
    })}
        </x-grid>
        ${EditExtensionData({
      host,
      content: {
        value: content,
        path: controllerBaseKeyPath,
        controller: contentController,
        extension: ContainerExtension
      },
      globalSettings,
      extensions
    })}
      </x-flex>
    `;
  }
};
var XContainerGridExtension = class extends XContainerExtension {
  getCountColumns() {
    const content = this._convertedContent;
    if (!content)
      throw new Error("content not found in grid extension");
    const defaultColumns = this.getValue("columns");
    if (defaultColumns && !content.columns)
      return defaultColumns;
    return content.ensuredColumns;
  }
  getCountRows() {
    const content = this._convertedContent;
    if (!content)
      throw new Error("content not found in grid extension");
    const defaultRows = this.getValue("rows");
    if (defaultRows && !content.rows)
      return defaultRows;
    return content.ensuredRows;
  }
  _content(content) {
    const renderables = [];
    const rows = this.getCountRows();
    const columns = this.getCountColumns();
    for (let i = 0; i < rows * columns; i++) {
      const classList = ["grid-item"];
      if (i < rows * columns - columns && content.tableView?.hasHorizontalSeperator) {
        const column = i % columns;
        if (column === 0)
          classList.push("line-below-max-right");
        else if (column === columns - 1)
          classList.push("line-below-max-left");
        else {
          classList.push("line-below-max-right");
          classList.push("line-below-max-left");
        }
        classList.push("grid-line-below");
      }
      if (i % columns !== 0 && content.tableView?.hasVerticalSeperator) {
        const row = Math.floor(i / columns);
        if (rows > 1) {
          if (row === 0)
            classList.push("line-left-max-bottom");
          else if (row === rows - 1)
            classList.push("line-left-max-top");
          else {
            classList.push("line-left-max-bottom");
            classList.push("line-left-max-top");
          }
        }
        classList.push("grid-line-left");
      }
      const cellContent = this._contentFilteredSorted?.find((base) => base.index === i);
      if (cellContent instanceof BaseContainer)
        classList.push("child-container-item");
      const wrapper = (content2) => html` <div class=${classList.join(" ")}>${content2}</div>`;
      if (cellContent) {
        renderables.push(
          wrapper(this.renderChild({ extensions: this._consumedExtensions.value ?? [], content: cellContent }))
        );
        continue;
      }
      if (this._consumedMode.value === "view") {
        renderables.push(wrapper(html``));
        continue;
      }
      renderables.push(
        wrapper(html`
          <x-buildify-dropzone no-swap .index=${i} .parentID=${this.content.value?._id}></x-buildify-dropzone>
        `)
      );
    }
    return html` ${renderables} `;
  }
  styles() {
    const gridColumnGap = this.getValue("gridColumnGap");
    const parsedGridColumnGap = Number.parseInt(gridColumnGap?.split("px")[0] ?? "");
    const gridRowGap = this.getValue("gridRowGap");
    const parsedGridRowGap = Number.parseInt(gridRowGap?.split("px")[0] ?? "");
    const separatorValues = {
      thickness: this.content.value?.tableView?.thickness ?? "2px",
      color: this.content.value?.tableView?.colorSeperators ?? "#000"
    };
    return [
      ...super.styles(),
      {
        ":host": {
          display: "grid !important",
          gridTemplateColumns: new Array(this.getCountColumns()).fill(null).map((_, index) => this._convertedContent?.getColumnWidthByIndex(index) || "1fr").join(" "),
          gridRowGap: this.getValue("gridRowGap"),
          gridColumnGap: this.getValue("gridColumnGap"),
          ...this.content.value?.revertDirection ? { gridAutoFlow: "dense", direction: "rtl" } : {},
          ...this._consumedMode.value === "edit" ? {
            border: "1px solid #333",
            padding: "10px"
          } : {}
        },
        ".grid-item": {
          position: "relative",
          ...this.content.value?.revertDirection ? { direction: "ltr" } : {}
        },
        ".grid-item > *": {
          width: "100%"
        },
        ".grid-item.child-container-item > :first-child": {
          boxSizing: "border-box",
          height: "100%"
        },
        ".grid-line-left::before": {
          content: "''",
          position: "absolute",
          left: parsedGridColumnGap ? `-${parsedGridColumnGap / 2}px` : "0",
          top: "0",
          bottom: "0",
          width: separatorValues.thickness,
          background: separatorValues.color,
          zIndex: "10"
        },
        ".grid-line-below::after": {
          content: "''",
          position: "absolute",
          bottom: parsedGridRowGap ? `-${parsedGridRowGap / 2}px` : "0",
          height: separatorValues.thickness,
          background: separatorValues.color,
          left: "0",
          right: "0",
          zIndex: "10"
        },
        ".grid-line-left.line-left-max-bottom::before": {
          bottom: parsedGridRowGap ? `-${parsedGridRowGap / 2}px` : "0"
        },
        ".grid-line-left.line-left-max-top::before": {
          top: parsedGridRowGap ? `-${parsedGridRowGap / 2}px` : "0"
        },
        ".grid-line-below.line-below-max-left::after": {
          left: parsedGridColumnGap ? `-${parsedGridColumnGap / 2}px` : "0"
        },
        ".grid-line-below.line-below-max-right::after": {
          right: parsedGridColumnGap ? `-${parsedGridColumnGap / 2}px` : "0"
        },
        "[edit-hover]": {
          width: "14px",
          height: "14px",
          background: "#333"
        }
      }
    ];
  }
};
XContainerGridExtension = __decorateClass([
  customElement("x-container-grid-extension")
], XContainerGridExtension);
export {
  ContainerGridExtension,
  XContainerGridExtension
};
